import { render, staticRenderFns } from "./LearningTheoryComment.vue?vue&type=template&id=2737585e"
import script from "./LearningTheoryComment.vue?vue&type=script&lang=js"
export * from "./LearningTheoryComment.vue?vue&type=script&lang=js"
import style0 from "./LearningTheoryComment.vue?vue&type=style&index=0&id=2737585e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports